import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { app } from "@/di";
import { ConfigRepository } from "@/modules/base/services/ConfigRepository";
export default /*#__PURE__*/_defineComponent({
  __name: 'FormationPicker',
  props: {
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const formations = ref(app.get(ConfigRepository).get('formations.all'));
    const options = computed(() => Object.keys(formations.value)
    // @ts-ignore
    .map(formation => ({
      value: formation,
      label: formation
    })));
    return (_ctx, _cache) => {
      const _component_NSelect = _resolveComponent("NSelect");
      return _openBlock(), _createBlock(_component_NSelect, _mergeProps(_ctx.$attrs, {
        options: _unref(options),
        value: __props.modelValue,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => _ctx.$emit('update:modelValue', $event))
      }), null, 16, ["options", "value"]);
    };
  }
});